import { render, staticRenderFns } from "./SubGroupPanel.vue?vue&type=template&id=36cdd948"
import script from "./SubGroupPanel.vue?vue&type=script&lang=js"
export * from "./SubGroupPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports